import { z } from 'zod';
export const FocusGroupWidgetKey = 'focus-group-widget:v1';
export const FocusGroupWidgetKind = 'focus_group';
export const FOCUS_GROUP_ARTIFACT_KEY_PREFIX = 'focus-group:';
const DivergentViewSchema = z.object({
    stat: z.string(),
    description: z.string(),
});
const RecommendationSchema = z.object({
    category: z.string(),
    action: z.string(),
    rationale: z.string(),
});
const NotableQuoteSchema = z.object({
    quote: z.string(),
    speaker: z.string(),
    speakerId: z.string(),
    speakerFullName: z.string().optional(),
    context: z.string().optional(),
});
const ExecutiveSummarySchema = z.object({
    overview: z.string(),
    keyInsights: z.array(z.string()),
    commonThemes: z.array(z.string()),
    divergentViews: z.array(DivergentViewSchema),
    recommendations: z.array(RecommendationSchema),
    notableQuotes: z.array(NotableQuoteSchema),
});
const PersonaSummarySchema = z.object({
    personaId: z.string(),
    personaName: z.string(),
    summary: z.string(),
    keyInsights: z.array(z.string()),
});
// The artifact stores a snapshot of the focus group data at save time.
// The Library preview fetches live data from persona-api via the focus group id
// encoded in the artifact key, so the stored fields aren't read by the preview today.
// They exist for forward-looking uses: offline export, snapshot-on-delete resilience,
// and potential widget rendering if the preview strategy changes.
export const FocusGroupWidgetSchema = z.object({
    title: z.string().nullable().optional(),
    brandName: z.string().nullable().optional(),
    userQuestions: z.string().nullable().optional(),
    executiveSummary: ExecutiveSummarySchema.nullable().optional(),
    personaSummaries: z.array(PersonaSummarySchema).nullable().optional(),
});
